var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29961 14.1676H3.99351C4.26631 14.1676 4.52273 14.0615 4.71536 13.8683L14.3602 4.21662C14.5528 4.02385 14.6592 3.76725 14.6592 3.49426C14.6592 3.22127 14.5528 2.96467 14.3602 2.77189L12.2562 0.666469C11.8705 0.280489 11.1982 0.280489 10.8125 0.666469L1.16817 10.3177C0.977684 10.5074 0.868652 10.7709 0.868652 11.0405V13.7363C0.868652 13.9744 1.06172 14.1676 1.29961 14.1676ZM3.99351 13.3064H1.73056V11.0419C1.73056 10.9996 1.74737 10.9595 1.77711 10.9293L11.4223 1.27767C11.5029 1.19659 11.5658 1.19659 11.6469 1.27767L13.7508 3.38309C13.7913 3.42363 13.7973 3.47107 13.7973 3.49565C13.7973 3.52023 13.7913 3.56767 13.7508 3.60821L4.10599 13.2599C4.07583 13.2901 4.03618 13.3064 3.99351 13.3064Z",
    fill: "#F79009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1604 5.219C12.2445 5.30309 12.3548 5.34536 12.4651 5.34536C12.5754 5.34536 12.6858 5.30352 12.7698 5.219C12.9383 5.05037 12.9383 4.77738 12.7698 4.60919L10.4189 2.25666C10.2504 2.08803 9.97807 2.08803 9.80957 2.25666C9.64106 2.42528 9.64106 2.69827 9.80957 2.86646L12.1604 5.219ZM3.54074 12.2687C3.6252 12.3812 3.75449 12.4407 3.8855 12.4407C3.97557 12.4407 4.0665 12.4127 4.14408 12.3545C4.33413 12.2114 4.37248 11.9412 4.22941 11.7512C3.96006 11.3922 3.64115 11.0737 3.28216 10.8035C3.09168 10.6613 2.8219 10.6992 2.67883 10.8892C2.53575 11.0793 2.5741 11.3495 2.76415 11.4926C3.0585 11.7137 3.31966 11.9748 3.54074 12.2687Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconOrange);
export default __webpack_public_path__ + "static/media/edit-icon-orange.02210cc817a3709e28bf1ea9205eeef6.svg";
export { ForwardRef as ReactComponent };